import { cn } from '@/lib/utils'

interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  size?: 'sm' | 'default' | 'lg'
  background?: 'white' | 'gray' | 'gradient' | 'dark'
}

const sectionSizes = {
  sm: 'py-12 md:py-16 lg:py-20',
  default: 'py-16 md:py-24 lg:py-32',
  lg: 'py-20 md:py-32 lg:py-40',
}

const sectionBackgrounds = {
  white: 'bg-panel',
  gray: 'bg-page',
  gradient: 'bg-gradient-to-b from-page to-panel',
  dark: 'bg-page',
}

export function Section({
  className,
  size = 'default',
  background = 'white',
  ...props
}: SectionProps) {
  return (
    <section
      className={cn(
        sectionSizes[size],
        sectionBackgrounds[background],
        className
      )}
      {...props}
    />
  )
}
